import React, { useState } from "react";
import Card from "../../shared/Card";
import TagsButtons from "../../shared/TagsButtons";
import { useWindowDimensions } from '../../shared/hooks/useWindowDimensions';
import { data } from "../../assets/strategies";
import Modal from "../../shared/Modal";
import "./Marketing.css";

const Marketing = () => {
  const [item, setItem] = useState(data);
  const [modalItem, setModalItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const { width } = useWindowDimensions();

  const arrtag = [];

  const tagItems = [
    ...new Set(arrtag.concat(data.map((item) => item.tags)).flat()),
  ];


  const filterItem = (curcat) => {
    const newItem = data.filter((newVal) => {
      return newVal.tags.find((el) => el === curcat);
    });
    setItem(newItem);
  };

  const ModalHandler = (curcat) => {
    const newItem = data.find((item) => item.id === curcat);
    setModalItem(newItem);
    setShowModal(true);
  };
  const CloseHandler = () => {
    setShowModal(false);
    
  }
  return (
    <div className="section-marketing" id="marketing">
      <h2 className="section-title">Marketing Strategies</h2>
      <p className="section-subtitle">
        Join 40,000+ other marketers and get proven strategies on email
        marketing
      </p>
      <TagsButtons
        filterItem={filterItem}
        setItem={setItem}
        tagItems={tagItems}
      />

      <Card item={item} click={ModalHandler} />
      <Modal
        className={showModal && "show-modal"}
        Close={CloseHandler}
        title={modalItem.title}
        img={modalItem.img}
        tags={modalItem.tags}
        desc={modalItem.desc}
        date={modalItem.date}
      />
    </div>
  );
};

export default Marketing;
